import React from 'react'
import { Card } from 'semantic-ui-react'
import LobbyNavBar from '../NavBar/LobbyNavBar'


function LandingPage() {
  return (
    <>
      <LobbyNavBar/>
      <div className='grid grid-flow-row-dense grid-cols-4'>
        <Card>asdfas</Card>
        <Card>asdfas</Card>
        <Card>asdfas</Card>
        <Card>asdfas</Card>
        <Card>asdfas</Card>
        <Card>asdfas</Card>
      </div>
    </>
  )
}

export default LandingPage